import * as React from 'react';

export interface IHoverContext {
  isHovered: boolean;
  toggleHover (): void;
}

export const HoverContext: React.Context<IHoverContext> =
  React.createContext<IHoverContext>({ isHovered: false, toggleHover: () => { return; } });

export const useHoverContext = () => React.useContext(HoverContext);
